import { TextareaAutosize } from "@material-ui/core"
import React, { useRef, useEffect, useState, useLayoutEffect } from "react"
import useIsWide from "src/utils/use-is-wide"
import { defForType } from "../../../shared/default-parameters-for-abi-inputs"
import store, { qs } from "../store"
import Tooltip from "./tooltip"
import { OverflowTipText } from "../utils/textOverflowToolTip"

/**
 * @param props {{
 * value?
 * label?
 * labelBackground?
 * style?
 * onChange?
 * children?
 * moreOptions?
 * [x:string]:any
 * isUpdateOnChange?:boolean
 * width?: string | number
 * wrapperWidth?: string | number
 * disabled?:boolean
 * optional?:boolean
 * showMaxButton?:boolean
 * }}
 */
export function Input(props = {}) {
  var isOneSide = store.getView() == "oneside"
  const [cursor, setCursor] = useState(null)
  const isWide = useIsWide()
  var isValid = true
  if (props.isValidFunc) {
    if (
      props.optional &&
      (props.value === "" || props.value === undefined || props.value === null)
    ) {
      isValid = true
    } else {
      isValid = props.isValidFunc(props.value)
    }
  }
  var width
  if (isWide) {
    if (props.width) {
      width = props.width
    } else {
      if (props.children) {
        width = "auto"
      } else {
        width = "450px"
      }
    }
  } else {
    width = "100%"
  }
  var style = {
    width: "100%",
    fontSize: 16,
    outline: "none",
    flexGrow: props.grow ? 1 : undefined,
    background: "inherit",
    [isOneSide ? (props.hideBottomBorder ? "none" : "borderBottom") : "border"]:
      // isOneSide ? 'none' :
      "1px solid " +
      (props.error || !isValid ? "#D9251C" : props.children ? "#000" : "#555"),
    ...(props.style || {}),
  }
  if (!isWide) {
    style.minWidth = "100%"
  }
  var inputStyle = {
    border: "none",
    background: "inherit",
    fontSize: "0.875rem",
    outline: "none",
    color: props.disabled && "#9e9e9e",
    cursor: props.disabled && "not-allowed",
    padding: "8px 16px 5px",
    flexGrow: 1,
  }
  var [internalValue, set_internalValue] = useState(props.value || "")

  var value = internalValue

  var a = useRef(null)
  function update(e) {
    setCursor(e.target.selectionStart)
    // props.onChange(e)
    set_internalValue(e.target.value)
  }
  useEffect(() => {
    if (a.current && (props.isUpdateOnChange || !a.current.value)) {
      a.current.value = value
    }
  }, [value])

  useEffect(() => {
    const input = a.current
    if (input) input.setSelectionRange(cursor, cursor)
  }, [a, cursor, value])

  function changeValue(value) {
    set_internalValue(value)
    onBlur()
  }

  useEffect(() => {
    if (props.autofocus) {
      a.current.focus()
    }
  }, [])

  // store.useRerenderIfChange(()=>[
  //   store.steps[store.selectedStep].parameters
  // ])

  function onBlur() {
    // console.log('blur',internalValue)
    set_internalValue((internalValue) => {
      props.onChange?.({ target: { value: internalValue } })
      if (props.onBlur) {
        props.onBlur()
      }
      return internalValue
    })
  }

  // The 5 lines below to fix a bug we switching between steps,
  // The inputs value not updated.
  var initialValue = useRef(props.value)
  useEffect(() => {
    if (props.value != initialValue && a.current) {
      a.current.value = props.value
    }
  }, [props.value])

  var { isValidFunc, ...otherProps } = props

  return (
    <div
      style={{
        position: isOneSide ? undefined : "relative",
        display: isOneSide ? "flex" : undefined,
        minWidth: props.wrapperWidth,
        color: props.disabled && "#9e9e9e",
        cursor: props.disabled && "not-allowed",
      }}
    >
      {isOneSide && (
        <div
          css={`
            width: 110px;
            vertical-align: middle;
            flex-shrink: 0;
            padding-top: 8px;
          `}
        >
          <OverflowTipText text={props.label} />
        </div>
      )}
      {!isOneSide && (
        <div
          style={{
            position: "absolute",
            background: props.labelBackground || "white", //rgb(246, 246, 250)
            left: 10,
            top: -10,
            fontSize: "0.75rem",
          }}
        >
          &nbsp;{props.label}&nbsp;&nbsp;
        </div>
      )}
      <div style={style}>
        {!props.children &&
          (props.multiline ? (
            <TextareaAutosize
              {...otherProps}
              style={{ ...inputStyle, width: "100%" }}
              ref={a}
              onBlur={onBlur}
              value={internalValue}
              onChange={(x) => {
                update(x)
              }}
              css="
          width: 100%;
          display: block;
          resize: vertical;"
            />
          ) : (
            <div
              css={`
                display: flex;
                align-items: center;
              `}
            >
              <input
                {...otherProps}
                value={internalValue}
                style={inputStyle}
                ref={a}
                // value={value}
                onBlur={onBlur}
                onChange={(x) => {
                  update(x)
                }}
              />
              <>
                {props?.type?.match?.(/address|bytes/) && (
                  <div
                    onClick={() => {
                      if (
                        (props.type == "address" || props.type == "bytes32") &&
                        typeof props["onAddBtnClick"] == "function"
                      ) {
                        props.onAddBtnClick()
                      }
                    }}
                    css={`
                      cursor: pointer;
                      font-size: 12px;
                      color: blue;
                    `}
                  >
                    RENAME &nbsp;
                  </div>
                )}
                {props?.type?.match?.(/uint|string|address|bytes/) && (
                  <div
                    onClick={() => {
                      changeValue(defForType(props.type))
                      if (
                        (props.type == "address" || props.type == "bytes32") &&
                        typeof props["onClear"] == "function"
                      ) {
                        props.onClear()
                      }
                    }}
                    css={`
                      cursor: pointer;
                      font-size: 14px;
                    `}
                  >
                    X
                  </div>
                )}
                {(props.maxValue && props.showMaxButton) && (
                  <div
                    css={`
                      cursor: pointer;
                      font-size: 14px;
                    `}
                    onClick={() => {
                      changeValue(props.maxValue)
                    }}
                  >
                    &nbsp;Max
                  </div>
                )}
              </>
            </div>
          ))}
        {props.children && props.children}
        {props.moreOptions}
      </div>
    </div>
  )
}
